
import { VerificationLayout } from "./VerificationLayout";
import { Skeleton } from "@/components/ui/skeleton";

export const VerificationLoading = () => {
  return (
    <VerificationLayout currentStep={2} totalSteps={3}>
      <div className="space-y-6 w-full">
        <div className="space-y-3">
          <Skeleton className="h-6 bg-gray-200 rounded w-3/4" />
          <Skeleton className="h-4 bg-gray-200 rounded w-1/2" />
        </div>
        
        <div className="space-y-3">
          <Skeleton className="h-10 bg-gray-200 rounded w-full" />
          <Skeleton className="h-10 bg-gray-200 rounded w-full" />
          <Skeleton className="h-10 bg-gray-200 rounded w-3/4" />
        </div>
        
        <div className="flex justify-end">
          <Skeleton className="h-10 w-28 bg-gray-200 rounded" />
        </div>
      </div>
    </VerificationLayout>
  );
};
